import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getBranchOfficeById } from "../../shared/utils/getBranchOffice"

export const queryBranchOffice = {
  async branchOffice(parent, args, context, info) {
    const { id, lang = AppSettings.defaultLocale(), cdn = true } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.BRANCHES,
      operation: Operations.READ,
    })

    if (typeof id !== "string") return null

    return await getBranchOfficeById(lang, context, cdn, id)
  },
}
